module.exports = __webpack_public_path__ + "img/QRCode.5352f7f2.svg";